import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProductionVehicles34_2bTable from "./Table";
import { ShowHide } from "../../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProductionVehicles34_2b = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("PRODUCTION_VEHICLES") || "Production Vehicles"}
        subDescription={t("PRODUCTION_VEHICLES_34_2B_DESC") || "Enter production vehicles energy usage"}
        isNormal={true}
        number={"34.2b"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`production-vehicles-34-2b-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <ProductionVehicles34_2bTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default ProductionVehicles34_2b;
